import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { IconName } from '../../icons-container/icons.type';
import { BadgeComponent } from '../badge/badge.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-product-selectable-card',
  templateUrl: './product-selectable-card.component.html',
  styleUrls: ['./product-selectable-card.component.less'],
  standalone: true,
  imports: [IconComponent, BadgeComponent, TranslatePipe],
  host: {
    '[class.active]': 'isActive',
  },
})
export class ProductSelectableCardComponent {
  @Input() public isActive: boolean = false;
  @Input() public iconName: IconName;
  @Input() public productName: string;
  @Input() public productType: string;
  @Input() public text: string;
}
